import { type ReactNode } from "react";
import { isPreviewEnvironment } from "@/utils/envUtils";
import { ClientOnly } from "@/components/ui/ClientOnly";
import { useCommonTranslation } from "@/features/i18n/libs/useCommonTranslation";
import { env } from "@/env";

type PreviewProtectionProps = {
  children: ReactNode;
};

function isLandingPage(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  return window.location.pathname === "/";
}

export function PreviewProtection({ children }: PreviewProtectionProps) {
  if (!isPreviewEnvironment()) {
    return children;
  }

  return (
    <ClientOnly showLoader={false}>
      <PreviewProtectionInner>{children}</PreviewProtectionInner>
    </ClientOnly>
  );
}

function PreviewProtectionInner({ children }: PreviewProtectionProps) {
  const { t } = useCommonTranslation();

  if (isLandingPage()) {
    return children;
  }

  const clientSecret = localStorage.getItem("preview_access_client_secret");
  const hasValidAccess = clientSecret === env.VITE_SUPER_USER_SECRET;

  if (!hasValidAccess) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          minHeight: "100%",
          fontFamily: "system-ui, sans-serif",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h1 style={{ fontSize: "4rem", margin: 0 }}>404</h1>
          <p style={{ fontSize: "1.5rem", color: "#666" }}>
            {t("common:not_found")}
          </p>
        </div>
      </div>
    );
  }

  return children;
}
